import { observable, makeObservable } from "mobx";

type ConfirmCallback = () => boolean | Promise<boolean>
type CancelCallback = () => void

class Confirm {
  @observable open: boolean = false
  @observable title: string = ''
  @observable content: any
  @observable buttons?: string[]
  @observable isProcessing: boolean = false

  onConfirm?: ConfirmCallback
  onCancel?: CancelCallback

  show = (title: string, content: any, buttons?: string[], onConfirm?: ConfirmCallback, onCancel?: CancelCallback) => {
    this.open = true
    this.title = title
    this.content = content
    this.onCancel = onCancel
    this.onConfirm = onConfirm
    this.buttons = buttons
    this.isProcessing = false
  }

  confirm = () => {
    if (this.onConfirm) {
      this.isProcessing = true
      const result = this.onConfirm()
      if (result instanceof Promise && result) {
        (result as Promise<boolean>).then((confirmed:boolean) => {
          this.open = !confirmed
          this.isProcessing = false
        })
      } else {
        this.open = !result
        this.isProcessing = false
      }
    }
  }

  cancel = () => {
    this.open = false
    if (this.onCancel) {
      this.onCancel()
    }
  }

  constructor() {
    makeObservable(this);
  }
}

export default Confirm